import React from "react";
// import Redux
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../store/reducers";
import { bindActionCreators } from "redux";
import { actionCreators } from "../store";
// import material
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

const CustomAlert = (props: any) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const Alert = () => {
  const dispatch = useDispatch();
  const { alert, langValue } = useSelector((state: RootState) => state.appReducer);
  const { alertHideState } =
    bindActionCreators(actionCreators, dispatch);
  const handleClose = () => {
    alertHideState({
      show: false,
      type: alert.type,
      message: alert.message,
    });
  };
  setTimeout(() => {
    if(alert.show){
        handleClose();
    }
  }, 3000);
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={alert.show}
      onClose={handleClose}
      style={langValue === "ar" ? { direction: "rtl" } : { direction: "ltr" }}
    >
      <CustomAlert
        onClose={handleClose}
        severity={alert.type ? alert.type : ""}
      >
        {alert.message}
      </CustomAlert>
    </Snackbar>
  );
};

export default Alert;
